export { default as JSONSort } from './JSONSort';
export { default as launchApplicationMarket } from './launchApplicationMarket';

export function uuid() {
  const tempUrl = URL.createObjectURL(new Blob());
  const uuid0 = tempUrl.toString();
  URL.revokeObjectURL(tempUrl); // 释放这个url
  return uuid0.substring(uuid0.lastIndexOf('/') + 1);
}

export function getVideoSnapshot(src, v = new Date().getTime()) {
  if (!src || /(jpg|png|gif|jpeg)$/.test(src)) return src || '';
  const backgroundImageUrl = /^http/.test(src) ? `${src.split('?')[0]}?x-oss-process=video/snapshot,t_1000,w_800,f_png,m_fast&v=${v}` : src;
  console.log(backgroundImageUrl);
  return backgroundImageUrl;
}

export function formatterDateText($datetime) {
  if (!$datetime) return '';
  const datetime = $datetime.split('.')[0].split('-').join('/');
  const preTime = new Date(datetime).getTime() / 1000 / 60;
  const nowTime = new Date().getTime() / 1000 / 60;

  if (nowTime - preTime < 1) {
    return '刚刚';
  }
  if (nowTime - preTime < 60) {
    return `${parseInt(nowTime - preTime, 10)}分钟前`;
  }
  if (nowTime - preTime > 60 && nowTime - preTime < 24 * 60) {
    return `${parseInt((nowTime - preTime) / 60, 10)}小时前`;
  }
  if (nowTime - preTime > 24 * 60) {
    console.log(new Date(datetime).getFullYear);
    return `${new Date(datetime).getFullYear()}.${new Date(datetime).getMonth() + 1}.${new Date(datetime).getDate()}`;
  }
  return '';
}

export function formatterCitys(citys) {
  const tempData = JSON.parse(JSON.stringify(citys));
  const areaList = {
    province_list: {},
    city_list: {},
    county_list: {},
  };
  tempData.forEach((item) => {
    areaList.province_list[item.code] = item.codeName;
    item.cityCodeVOList.forEach((ite) => {
      if (ite.code == '810000' || ite.code == '820000') {
        ite.code = ite.code.slice(0, 2) + '01' + ite.code.slice(4);
        console.log(ite.code);
        areaList.city_list[ite.code] = ite.codeName;
        ite.cityCodeVOList.forEach((it) => {
          it.code = it.code.slice(0, 2) + '01' + it.code.slice(4);
          areaList.county_list[it.code] = it.codeName;
        });
      } else {
        areaList.city_list[ite.code] = ite.codeName;
        ite.cityCodeVOList.forEach((it) => {
          areaList.county_list[it.code] = it.codeName;
        });
      }
    });
  });
  return areaList;
}

export default { uuid };
